import { Injectable } from '@angular/core';
import { InaxTranslateService } from './../../../translate/src/translate';
import { motionUiTranslations } from './translations';


@Injectable()
/**
 * This resource manager handles the registration of the texts of this module in the translation service.
 * The best way is to inject this manager in the module constructor.
 * @class AlarmUiResourceManager
 * @classdesc Resource class to handle texts in different languages of the current module
 * @author insite-gmbh
 */
export class MotionUiResourceManager {
    
    /**
     * The class constructor adds the texts to the translation service.
     * @param {InaxTranslateService} _translations The translationservice handles the UI Text translation.
    */
    constructor(private _translations: InaxTranslateService) {
        _translations.addTranslations(motionUiTranslations);
    }
}